(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6444],{

/***/ 66444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23615);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60042);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _SkillSet_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7421);
/* harmony import */ var _SkillSet_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_SkillSet_module_scss__WEBPACK_IMPORTED_MODULE_2__);




var Tags = function(param) {
    var className = param.className, tags = param.tags, style = param.style, count = param.count, isWp = param.isWp;
    if (!tags.length) return null;
    var endIndex = (count && count > tags.length ? tags.length : count) || tags.length;
    var extractedTags = tags.slice(0, endIndex);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_SkillSet_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), isWp && (_SkillSet_module_scss__WEBPACK_IMPORTED_MODULE_2___default().wpContainer), className),
        style: style,
        children: extractedTags.map(function(tag, j) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_SkillSet_module_scss__WEBPACK_IMPORTED_MODULE_2___default().item),
                children: isWp ? tag.name : tag
            }, j);
        })
    });
};
Tags.propTypes = {
    className: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
    tags: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().array),
    count: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().number),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().object),
    isWp: (prop_types__WEBPACK_IMPORTED_MODULE_3___default().bool)
};
/* harmony default export */ __webpack_exports__["default"] = (Tags);


/***/ }),

/***/ 7421:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"SkillSet_container__h3e3U","wpContainer":"SkillSet_wpContainer__aRFOm","centered":"SkillSet_centered__csvOm","item":"SkillSet_item__QlVGK","darkItem":"SkillSet_darkItem__c5Glh"};

/***/ })

}]);